export const CardioSection = ({
    newCardioName,
    setNewCardioName,
    addCardioLabel,
    cardioList,
    removeCardio
}) => {
    return (
        <section>
            <div className="card p-6 mb-4">
                <p className="text-[11px] font-black text-slate-400 uppercase mb-3 px-1">유산소 종목 관리</p>
                <div className="flex gap-2 mb-6">
                    {/* 종목 이름 입력 */}
                    <input 
                        type="text" 
                        value={newCardioName} 
                        onChange={(e) => setNewCardioName(e.target.value)} 
                        className="flex-1 bg-slate-50 px-4 py-4 rounded-2xl border-none font-semibold" 
                        placeholder="유산소 종목 입력 (예: 러닝머신)" 
                    />
                    
                    {/* 추가 버튼 */}
                    <button 
                        onClick={addCardioLabel} 
                        className="shrink-0 bg-slate-900 text-white px-5 rounded-2xl font-bold"
                    >
                        추가
                    </button>
                </div>
                
                {/* 유산소 종목 리스트 출력 */}
                <div id="cardioLabelsContainer" className="flex flex-wrap gap-2">
                    {cardioList.map((cardio, index) => (
                        <div 
                            key={index} 
                            className="bg-teal-50 px-4 py-2 rounded-xl text-xs font-bold text-teal-600 flex items-center gap-2"
                        >
                            {/* 종목 이름만 출력되도록 수정 */}
                            {cardio.name}
                            <span 
                                onClick={() => removeCardio(cardio.name)} 
                                className="material-icons-round text-sm cursor-pointer"
                            >
                                cancel
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}